import { InvoiceList } from "./Sales";

export default function Purchases() {
  return <InvoiceList type="purchase" />;
}
